import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  text: {
    color: theme.palette.white,
    marginLeft: 12,
    marginTop: 12,
  },
  circle: {
    marginTop: 16,
  },
}));
